import {
  BackgroundGrid,
  DataWrapper,
  DetailsWrapper,
  EmblemImage,
  EmblemImageWrapper,
  LeaderBoardWrapper,
  NumberContainer,
  Table,
  TableHead,
  TableRow,
  TableWrapper,
  TitleWrapper,
  WoodImg,
  YellowLineExternal,
  YellowLineInternal,
  TableCell,
} from "./LeaderBoardPage.style";
import BigWhiteX from "../../assets/big-white-x.svg";
import {
  CloseQuiz,
  CloseQuizContainer,
  CloseSVG,
} from "../QuizPage/QuizPage.style";
import { useNavigate } from "react-router-dom";
import Wood from "../../assets/wood-yellow.png";
import Bg from "../../assets/bg-grid.svg";
import Text from "../../components/Text";
import { useEffect, useState } from "react";
import { fetchLeaderboard } from "../../API/leaderboard";
import { getEmblemImagePath } from "../../API/emblem";

export const LeaderBoardPage = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  useEffect(() => {
    const loadLeaderboard = async () => {
      try {
        const res = await fetchLeaderboard();
        if (res.success) {
          setData(res.data);
        } else {
          console.error("Leaderboard fetch error:", res.message);
        }
      } catch (err) {
        console.error("Leaderboard fetch error:", err);
      }
    };

    loadLeaderboard();
  }, []);

  return (
    <LeaderBoardWrapper>
      <BackgroundGrid src={Bg} />
      <CloseQuizContainer>
        <CloseQuiz onClick={() => navigate("/")}>
          <CloseSVG src={BigWhiteX} />
        </CloseQuiz>
      </CloseQuizContainer>

      <DetailsWrapper>
        <TitleWrapper>
          <Text
            fontFamily="'Source Serif 4'"
            fontSize="40px"
            fontWeight="700"
            color="#3F626A"
            lineheight="100%"
          >
            Κατατάξη
          </Text>
        </TitleWrapper>

        <WoodImg src={Wood} />
        <YellowLineExternal>
          <YellowLineInternal>
            <DataWrapper>
              <TableWrapper>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell>
                        <Text fontFamily="Manrope" fontSize="16px" fontWeight="400" color="#FFFBEC">
                          Όνομα
                        </Text>
                      </TableCell>
                      <TableCell>
                        <Text fontFamily="Manrope" fontSize="16px" fontWeight="400" color="#FFFBEC" textalign="center">
                          Κάστρα
                        </Text>
                      </TableCell>
                      <TableCell>
                        <Text fontFamily="Manrope" fontSize="16px" fontWeight="400" color="#FFFBEC" textalign="center">
                          Σκορ
                        </Text>
                      </TableCell>
                      <TableCell>
                        <Text fontFamily="Manrope" fontSize="16px" fontWeight="400" color="#FFFBEC" textalign="center">
                          Έμβλημα
                        </Text>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {data.map((item, index) => (
                    <TableRow
                      key={index}
                      style={{
                        backgroundColor: index === 0 ? "#F3DE8A" : "#fffbec",
                      }}
                    >
                      <TableCell>
                        <NumberContainer>
                          <Text
                            fontFamily="'Source Serif 4'"
                            fontSize="17px"
                            fontWeight="700"
                            color="#FFFBEC"
                          >
                            {index + 1}
                          </Text>
                        </NumberContainer>
                      </TableCell>
                      <TableCell>
                        <Text fontFamily="Manrope" fontSize="16px" fontWeight="400" color="#3E626A">
                          {item.username}
                        </Text>
                      </TableCell>
                      <TableCell>
                        <Text fontFamily="Manrope" fontSize="16px" fontWeight="400" color="#3E626A" textalign="center">
                          {item.castles}/11
                        </Text>
                      </TableCell>
                      <TableCell>
                        <Text fontFamily="Manrope" fontSize="16px" fontWeight="400" color="#3E626A" textalign="center">
                          {item.score}
                        </Text>
                      </TableCell>
                      <TableCell>
                        <EmblemImageWrapper
                          style={{
                            backgroundColor: index === 0 ? "#FFFBEC" : "#F3DE8A",
                          }}
                        >
                          <EmblemImage
                            src={getEmblemImagePath(item.emblem_id || 1, item.color || "blue")}
                            alt={`Emblem ${item.emblem_id}`}
                          />
                        </EmblemImageWrapper>
                      </TableCell>
                    </TableRow>
                  ))}
                </Table>
              </TableWrapper>
            </DataWrapper>
          </YellowLineInternal>
        </YellowLineExternal>
      </DetailsWrapper>
    </LeaderBoardWrapper>
  );
};
